module.exports = __webpack_public_path__ + "img/bkash.9ca3bb3f.svg";